import React from 'react';
import PropTypes from 'prop-types';
import _, { filter, get } from 'underscore';
import { Dropdown } from '@fluentui/react';
import Promise from 'bluebird';
import config from '@bingads-webui-component-legacy/config';
import { adUnits } from './placements';
import { DoubleListBox } from './double-list-box';
import { getAdUnitData, getTriggerIdsData } from './placement-repository';


const amplifyPublisherId = 251978541;
const NoTriggerId = 0;

export class BoostPlacementTarget extends React.Component {
  constructor(props) {
    super(props);

    const selectedTrigger = get(this.props, ['boostSetting', 'triggerIds', '0'], NoTriggerId);
    const permissions = config.get('Permissions') || {};
    this.isBoostTriggerEnabled = permissions.IsAmplifyEnabled && permissions.dynamic && permissions.dynamic.EnableBoostTriggerSetting;

    this.state = {
      selectedOptions: [],
      options: [],
      triggerOptions: [],
      selectedTrigger: this.isBoostTriggerEnabled ? String(selectedTrigger) : null,
    };
  }

  componentDidMount() {
    const isBoostAdUnitAPIEnabled = _.result(config.get('Permissions'), 'IsBoostAdUnitAPIEnabled', false);
    const p$adUnits = isBoostAdUnitAPIEnabled ? getAdUnitData() : Promise.resolve(adUnits);

    p$adUnits.then((data) => {
      const selectionOptions = data.map(adUnit => ({
        ...adUnit,
        selected: get(this.props, ['boostSetting', 'adUnitIds'], []).includes(adUnit.key),
      }));

      const selectedOptions = filter(selectionOptions, option => option.selected === true);

      this.setState({
        selectedOptions,
        options: selectionOptions,
      }, () => {
        this.props.onDataChange(this.getData());
      });
    });

    getTriggerIdsData(this.props.i18n, this.isBoostTriggerEnabled).then((data) => {
      this.setState({
        triggerOptions: data,
      });
    });
  }

  onChange = (options) => {
    this.setState({ selectedOptions: options }, () => {
      this.props.onDataChange(this.getData());
    });
  };

  onChangeTrigger = (event, option) => {
    this.setState({ selectedTrigger: option.key }, () => {
      this.props.onDataChange(this.getData());
    });
  };

  getData = () => {
    const { selectedOptions, selectedTrigger } = this.state;
    const result = {
      BoostAdunitIds: '',
      BoostPublisherIds: '',
      BoostAccountIds: '',
      BoostTriggerIds: '',
    };

    if (selectedOptions.length > 0) {
      result.BoostAdunitIds = selectedOptions.map(option => option.key).join(';');
    } else {
      // when no explicit targets selected, send amplify publisher
      result.BoostPublisherIds = String(amplifyPublisherId);
    }

    if (selectedTrigger) {
      result.BoostTriggerIds = selectedTrigger;
    }

    return result;
  };

  render() {
    const { i18n, hideHeader } = this.props;
    const { options, triggerOptions } = this.state;

    const style = {
      borderTop: '1px solid black',
      marginTop: 20,
    };

    return (
      <div style={!hideHeader ? style : {}} >
        {!hideHeader && (<h4>Placement Targeting</h4>)}
        <div>{i18n.getString(_TL_('Show your Ad in only the selected placements. Choose the Placement Tags you want to target.'))}</div>
        { options.length > 0 &&
          <DoubleListBox
            selectorHeader={`${i18n.getString(_TL_('Adunit names'))}: ${options.length}`}
            data={options}
            onChange={this.onChange}
          />
        }

        {triggerOptions.length > 0 &&
        <>
          <div style={{ paddingBottom: 20 }} />
          <Dropdown
            options={this.state.triggerOptions}
            aria-labelledby="trigger-dropdown-text"
            selectedKey={this.state.selectedTrigger}
            onChange={this.onChangeTrigger}
            label={i18n.getString(_TL_('Select the eligible user action.'))}
            style={{ width: 400 }}
            className="boost-trigger-dropdown"
          />
        </>
        }
      </div>
    );
  }
}

BoostPlacementTarget.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  boostSetting: PropTypes.shape({
    adUnitIds: PropTypes.arrayOf(PropTypes.string),
  }),
  hideHeader: PropTypes.bool,
  onDataChange: PropTypes.func,
};

BoostPlacementTarget.defaultProps = {
  boostSetting: {
    adUnitIds: [],
  },
  hideHeader: false,
  onDataChange: _.noop,
};

